import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message);
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <footer className="relative border-t border-[#2A1F14]/10 bg-[#F7EFE0] constellation">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-5">
              <span className="font-display text-2xl tracking-[0.2em] text-[#2A1F14]">LUX</span>
              <span className="w-1 h-1 rounded-full bg-gold" />
              <span className="font-display text-2xl tracking-[0.2em] text-gold">AETERNA</span>
            </div>
            <p className="font-display italic text-xl text-[#2A1F14]/70 max-w-md">"Dove l'impossibile diventa possibilità."</p>
            <p className="text-[#2A1F14]/40 text-sm mt-6 max-w-md leading-relaxed">Il punto di riferimento italiano della spiritualità moderna e della formazione Akashica.</p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] text-gold mb-5">Esplora</h4>
            <ul className="space-y-3 text-sm text-[#2A1F14]/60">
              <li><Link className="hover:text-[#2A1F14] transition-colors" to="/servizi">Servizi</Link></li>
              <li><Link className="hover:text-[#2A1F14] transition-colors" to="/academy">Lux Academy</Link></li>
              <li><Link className="hover:text-[#2A1F14] transition-colors" to="/eventi">Eventi</Link></li>
              <li><Link className="hover:text-[#2A1F14] transition-colors" to="/blog">Blog</Link></li>
              <li><Link className="hover:text-[#2A1F14] transition-colors" to="/fondatore">Fondatore</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] text-gold mb-5">Newsletter</h4>
            <p className="text-sm text-[#2A1F14]/50 mb-4">Ricevi ispirazione e aggiornamenti sui percorsi.</p>
            <form onSubmit={subscribe} className="flex flex-col gap-3" data-testid="newsletter-form">
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="La tua email" data-testid="newsletter-email"
                className="bg-transparent border-b border-[#2A1F14]/20 py-2 text-sm focus:border-gold outline-none transition-colors"
              />
              <button disabled={loading} data-testid="newsletter-submit" className="self-start text-sm text-gold link-underline">
                {loading ? "Iscrizione..." : "Iscriviti →"}
              </button>
            </form>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#2A1F14]/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#2A1F14]/40">
          <span>© {new Date().getFullYear()} LUX AETERNA. Tutti i diritti riservati.</span>
          <div className="flex flex-wrap gap-x-5 gap-y-1">
            <Link data-testid="footer-privacy" to="/legal/privacy" className="hover:text-gold transition-colors">Privacy Policy</Link>
            <Link data-testid="footer-cookie" to="/legal/cookie" className="hover:text-gold transition-colors">Cookie Policy</Link>
            <Link data-testid="footer-termini" to="/legal/termini" className="hover:text-gold transition-colors">Termini &amp; Condizioni</Link>
          </div>
          <span>Assistente digitale · ARIES · Operatore PHYL®</span>
        </div>
      </div>
    </footer>
  );
}
